module.exports = __webpack_public_path__ + "img/foto 2.fa95566f.jpg";